// Remove this file on clean up of 'remove_nin_changeboarding_rll_usages'
import React, { type ReactNode, type ComponentType } from 'react';
import { SpotlightTarget } from '@atlaskit/onboarding';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import { componentWithFG } from '@atlassian/jira-feature-gate-component';

export type SpotlightTargetProps = {
	children: ReactNode;
	engagementId: string;
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const EngagementSpotlightAsync = lazy<ComponentType<{ engagementId: string }>>(
	() =>
		import(/* webpackChunkName: "async-engagement-spotlight" */ '@atlassiansox/engagekit-ts').then(
			({ EngagementSpotlight }) => EngagementSpotlight,
		),
	{ ssr: false },
);

const OldSpotlightTourTarget = ({ children, engagementId }: SpotlightTargetProps) => (
	<>
		<SpotlightTarget name={engagementId}>{children}</SpotlightTarget>
		<JSErrorBoundary
			packageName="jiraIssueNavigatorChangeboarding"
			id="async-engagement-spotlight"
			sendToPrivacyUnsafeSplunk
			fallback="unmount"
		>
			<Placeholder name="async-engagement-spotlight">
				<EngagementSpotlightAsync engagementId={engagementId} />
			</Placeholder>
		</JSErrorBoundary>
	</>
);

const SpotlightTourTarget = componentWithFG(
	'remove_nin_changeboarding_rll_usages',
	() => <></>,
	OldSpotlightTourTarget,
);

export default SpotlightTourTarget;
